<template>
  <ActicsLeftMenu>
    <template #app>
      <router-link class="p-3" :to="{ name: 'callPlanning' }">
        <span class="nexa-black extra-bold">C</span>
        <span class="nexa-regular">P</span>
      </router-link>
    </template>
  </ActicsLeftMenu>
</template>

<script>
import ActicsLeftMenu from '../layout/actics/ActicsLeftMenu.vue'
export default {
  components: { ActicsLeftMenu },
}
</script>

<style lang="scss" scoped>
.router-link-active {
  background-color: rgba(133, 199, 211, 0.23);
}
</style>